import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { Modal, Tooltip, Alert } from 'bootstrap';
import { Fancybox } from "@fancyapps/ui";

import '../components/axios.js';
import Cookie from '../../../../dev/js/components/cookie.js';
import initPrototypes from '../components/prototypes.js';
import { getPublicUrl, detectLanguageParameter } from '../components/utils.js';
import RatingInputService from '../services/rating-input-service.js';
import ImageUploaderService from '../services/image-uploader-service.js';
import AuthService from '../services/auth-service.js';
import ReCaptchaService from '../services/recaptcha-service.js';

window.BS_VERSION = parseFloat(Tooltip.VERSION);
window.dataLayer = window.dataLayer || [];
window.Cookie = Cookie;
initPrototypes();

class Review {
	constructor() {
		window.authService = this.authService = new AuthService();
		this.authService.init();
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore

		this.usedAi = null;
		this.originalLanguage = null;
		this.originalReviewText = '';
		this.isLoading = false;
		this.minWordsCount = 5;
		this.reviewLanguage = detectLanguageParameter();
		this.form = document.getElementById('write-review');
		this.reviewInputSelector = 'textarea[name="text"]';
		this.titleInputSelector = 'input[name="title"]';
		this.btn = this.form.querySelector('.btn-submit');
		this.isWriteReviewLoading = null;
		this.isOldReviewConfirmed = null;
		this.ratingInputService = new RatingInputService();
		this.imageUploaderService = new ImageUploaderService('.image-uploader:not(.d-none)', 10);

		this.ratingInputService.setupInputListener();
		this.initReviewWrite();

		Fancybox.bind("[data-fancybox]");

		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
		const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
	}

	initReviewWrite() {
		this.form.addEventListener('submit', (event) => this.handleSubmit(event));
		this.form.querySelector(this.reviewInputSelector).addEventListener('keyup', (event) => this.handleReviewChange(event));
		this.form.querySelector(this.titleInputSelector).addEventListener('click', (event) => this.handleReviewChanged(event));
		this.form.querySelector(this.reviewInputSelector + ' + .ai-badge').addEventListener('click', (event) => this.requestAiAssist(event));
		this.form.querySelector(this.titleInputSelector + ' + .ai-badge').addEventListener('click', (event) => this.requestAiSummarize(event));
		this.form.querySelector('input[name="date_of_experience"]').addEventListener('change', () => this.checkDateOfExperienceInput());
		document.addEventListener('click', (event) => {
			if (event.target.closest('.review-exists .review-details a.btn-secondary')) {
				window.dataLayer.push({ event: 'review_keep' });
			}
		});
	}

	handleSubmit(event) {
		event.preventDefault();
		event.stopPropagation();
		console.log('submit');

		if (this.isLoading || this.isWriteReviewLoading) {
			console.log('already loading, skip submit');
			return;
		}

		if (!this.authService.checkAuth()) {
			console.log('auth false');
			window.authService.showDialog();
			this.authService.on('closed', () => {
				console.log('closed event fired');
				this.toggleLoadingAnimation(true);

				if (this.authService.checkAuth()) {
					console.log('re-submit');
					this.handleSubmit(event);
				} else {
					console.log('closed without auth');
					this.toggleLoadingAnimation(false);
				}
			});

			return;
		}

		if (!this.validateForm()) {
			console.log('validateForm false');
			return;
		}

		// Call process
		// this.isWriteReviewLoading = false;
		this.isOldReviewConfirmed = false;

		// Show loading
		this.btn = this.form.querySelector('.btn-submit');
		this.toggleLoadingAnimation(true);

		this.request();
	}

	handleReviewChange(event) {
		console.log('handleReviewChange');
		this.originalLanguage = null;
		this.originalReviewText = event.target.value;
		if (event.target.value.split(' ').filter(item => item !== null && item !== ' ' && item !== '').length >= this.minWordsCount) {
			event.target.parentNode.querySelector('.ai-badge').style.display = 'inline-block';
		} else {
			event.target.parentNode.querySelector('.ai-badge').style.display = 'none';
			this.toggleAiTitleButton(false);
		}
	}

	handleReviewChanged(event) {
		console.log('handleReviewChanged');
		const textValue = this.form.querySelector(this.reviewInputSelector).value;
		const reviewTitle = this.form.querySelector(this.titleInputSelector).value;
		if (textValue.split(' ').filter(item => item !== null && item !== ' ' && item !== '').length >= this.minWordsCount && reviewTitle.length === 0 && !this.isLoading) {
			this.toggleAiTitleButton(true);
		} else {
			this.toggleAiTitleButton(false);
		}
	}

	requestAiAssist(event) {
		event.preventDefault();
		this.isLoading = true;
		this.toggleAiTitleButton(false);

		if (event.target.classList.contains('disabled')) {
			return;
		}

		this.toggleAiAnimation(true);

		const url = `${getPublicUrl()}/api/review/${this.form.dataset.company}/assist`;
		const formData = new FormData(this.form);
		const data = {
			'rating': formData.get('rating'),
			'text': this.originalReviewText,
			'language': this.originalLanguage,
		};

		this.reCaptchaService.runWithCaptcha("company_review_ai_assist", (token, withCheckbox = false) => {
			data.recaptcha_token = token;
			data.recaptcha_checkbox = withCheckbox;

			return axios.put(url, data)
				.then((response) => {
					console.log("company_review_ai_assist", response);

					if (this.originalLanguage === null) {
						this.originalLanguage = response.data.language;
					}
					this.reviewLanguage = response.data.language;
					this.form.querySelector(this.reviewInputSelector).value = response.data.review;
					this.form.querySelector(this.titleInputSelector).value = response.data.title;
					this.toggleAiAnimation(false);
					this.isLoading = false;
					this.usedAi = "rewrite";
				})
				.catch((error) => {
					console.error("company_review_ai_assist", error);
					this.toggleAiAnimation(false);
					this.isLoading = false;
					if (error.status === 429) {
						event.target.disabled = true;
						event.target.classList.add('disabled');
						event.target.setAttribute('data-bs-original-title', 'Too many requests. Please try again later.');
					}
				});
		});
	}

	requestAiSummarize(event) {
		event.preventDefault();

		if (event.target.classList.contains('disabled')) {
			return;
		}

		this.toggleAiAnimation(true, event.target);

		const url = `${getPublicUrl()}/api/review/${this.form.dataset.company}/summarize`;
		const formData = new FormData(this.form);
		const data = {
			'rating': formData.get('rating'),
			'text': this.originalReviewText,
			'language': this.originalLanguage,
		};


		this.reCaptchaService.runWithCaptcha("company_review_ai_summarize", (token, withCheckbox = false) => {
			data.recaptcha_token = token;
			data.recaptcha_checkbox = withCheckbox;

			return axios.put(url, data)
				.then((response) => {
					console.log("company_review_ai_summarize", response);

					if (this.originalLanguage === null) {
						this.originalLanguage = response.data.language;
					}
					this.reviewLanguage = response.data.language;
					this.form.querySelector('[name="title"]').value = response.data.title;
					this.toggleAiAnimation(false, event.target);
					this.toggleAiTitleButton(false);
					this.usedAi = "title";
				})
				.catch((error) => {
					console.error("company_review_ai_summarize", error);
					this.toggleAiAnimation(false, event.target);
					if (error.status === 429) {
						event.target.disabled = true;
						event.target.classList.add('disabled');
						event.target.setAttribute('data-bs-original-title', 'Too many requests. Please try again later.');
					}
				});
		});
	}

	request() {
		if (this.isWriteReviewLoading) {
			this.toggleLoadingAnimation(false);
			return;
		}

		this.isWriteReviewLoading = true;

		if (!this.isOldReviewConfirmed) {
			this.reviewCheck();
		} else {
			this.reviewWrite();
		}
	}

	reviewCheck() {
		const url = `${getPublicUrl()}/api/review/${this.form.dataset.company}/check`;
		const data = new FormData(this.form);
		data.append('lang', detectLanguageParameter());

		document.querySelectorAll('.image-uploader .item').forEach(item => {
			data.append('photos[]', item.querySelector('.image img').src);
			data.append('captions[]', item.querySelector('textarea').value);
		});

		axios.post(url, data)
			.then((response) => {
				console.log('check-review', response);
				this.isWriteReviewLoading = false;
				response = response.data;

				if (response.is_blocked_spammer) {
					document.querySelector('#write-review').style.display = 'none';
					document.querySelector('.review-exists').style.display = 'none';
					document.querySelector('.notification.review-saved').style.display = 'none';
					document.querySelector('.notification.blocked-spammer').style.display = 'block';
				} else if (response.exists) {
					window.dataLayer.push({ event: 'review_exists' });
					document.querySelector('#older-review').innerHTML = response.review;
					document.querySelector('#older-review .review-actions').style.pointerEvents = 'none';
					document.querySelector('#write-review').style.display = 'none';
					document.querySelector('.review-exists').style.display = 'block';

					// Format old review
					document.querySelector('#older-review .review-details .ti-review-content').TI_format().TI_shorten({
						'showLines': 5,
						'lessText': '<i class="ri-arrow-up-s-line" aria-hidden="true"></i> ' + document.body.dataset.lessText,
						'moreText': '<i class="ri-arrow-down-s-line" aria-hidden="true"></i> ' + document.body.dataset.moreText
					});

					document.querySelector('.review-exists .btn-confirm').addEventListener('click', (event) => {
						event.preventDefault();
						window.dataLayer.push({ event: 'review_overwrite' });
						window.dataLayer.push({ event: 'review_submit' });

						document.querySelector('.review-exists .btn-secondary').style.pointerEvents = 'none';
						this.btn = event.target;
						this.btn.blur();
						this.toggleLoadingAnimation(true);

						this.isOldReviewConfirmed = true;
						this.request();
					});
				} else {
					this.isOldReviewConfirmed = true;
					window.dataLayer.push({ event: 'review_submit' });
					this.request();
				}
			})
			.catch((error) => {
				console.error('check-review', error);
				this.isWriteReviewLoading = false;
				if (error.response && error.response.status === 400) {
					let errorText = document.querySelector('.error-text.contains-personal-data');
					if (errorText) {
						errorText.style.display = 'block';
						window.scroll({ top: errorText.offsetTop, behavior:'smooth' });
					}
					this.toggleLoadingAnimation(false);
				} else if (error.message === 'Request body exceeds the maximum allowed size.') {
					let errorText = document.querySelector('.error-text.size-limit');
					if (errorText) {
						errorText.style.display = 'block';
						window.scroll({ top: errorText.offsetTop, behavior:'smooth' });
					}
					this.toggleLoadingAnimation(false);
				} else {
					let errorTexts = document.querySelectorAll('.error-text');
					errorTexts.forEach(el => el.style.display = 'none');
				}
			});
	}

	reviewWrite() {
		const url = `${getPublicUrl()}/api/review/${this.form.dataset.company}/write`;
		const data = new FormData(this.form);

		data.append('lang', detectLanguageParameter());

		document.querySelectorAll('.image-uploader .item').forEach(item => {
			data.append('photos[]', item.querySelector('.image img').src);
			data.append('captions[]', item.querySelector('textarea').value);
		});

		this.reCaptchaService.runWithCaptcha("company_review_write", (token, withCheckbox = false) => {
			data.append('recaptcha_token', token);
			data.append('recaptcha_checkbox', withCheckbox);

			if (this.usedAi !== null) {
				data.append('usedAi', this.usedAi);
			}

			return axios.post(url, data)
				.then((response) => {
					console.log("company_review_write", response);
					document.querySelector('#write-review').style.display = 'none';
					document.querySelector('.review-exists').style.display = 'none';
					document.querySelector('.notification.review-saved').style.display = 'block';
					this.toggleLoadingAnimation(false);
					this.isWriteReviewLoading = false;
				})
				.catch((error) => {
					console.error("company_review_write", error);
					this.toggleLoadingAnimation(false);
					this.isWriteReviewLoading = false;
				});
		});
	}

	toggleLoadingAnimation(isLoading) {
		console.log('toggleLoadingAnimation', isLoading, this.btn);
		if (isLoading) {
			this.btn.classList.add('loading');
			this.btn.disabled = true;
		} else {
			this.btn.classList.remove('loading');
			this.btn.disabled = false;
		}
	}

	toggleAiAnimation(isLoading, btn = null) {
		console.log('toggleLoadingAnimation', isLoading);
		if (!btn) {
			btn = this.form.querySelector('.ai-badge');
		}
		if (isLoading) {
			btn.classList.add('loading');
		} else {
			btn.classList.remove('loading');
		}
	}

	toggleAiTitleButton(show) {
		if (show) {
			this.form.querySelector(this.titleInputSelector + ' + .ai-badge').style.display = 'inline-block';
			this.form.querySelector(this.titleInputSelector).style['padding-right'] = '95px';
		} else {
			this.form.querySelector(this.titleInputSelector + ' + .ai-badge').style.display = 'none';
			this.form.querySelector(this.titleInputSelector).style['padding-right'] = '0px';
		}
	}

	checkDateOfExperienceInput() {
		const input = document.querySelector('input[name="date_of_experience"]');
		const regex = /^[0-9]{4}\-([0][1-9]|[1][0-2])\-([0][1-9]|[1-2][0-9]|[3][0-1])$/;

		input.classList.remove('text-danger');
		input.parentElement.querySelector('.invalid-input').style.display = 'none';

		if (input.value.length && (!regex.test(input.value) || (new Date(input.value)).getTime() > (new Date().getTime()))) {
			input.classList.add('text-danger');
			input.parentElement.querySelector('.invalid-input').style.display = 'block';
			return false;
		}

		return true;
	}

	validateForm() {
		// Hide all error messages
		document.querySelectorAll('#write-review .error-text').forEach(el => el.style.display = 'none');

		// Validate form
		// if (!document.querySelector('#accept-terms').checked) {
		//     document.querySelector('#write-review .error-text.policy').style.display = 'block';
		//     return;
		// }
		if (!document.querySelector("form").rating.value) {
			document.querySelector('#write-review .error-text.rating').style.display = 'block';
			window.scroll({ top: document.querySelector('#write-review .error-text.rating').offsetTop, behavior:'smooth' });
			return false;
		}

		if (!this.checkDateOfExperienceInput()) {
			return false;
		}

		return true;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new Review();
});